/* global
    $:true,
    _:true,
    Backbone:true,
    Rover:true
*/

// eslint-disable-next-line filenames/match-regex
(() => {
  Rover = Rover || {};
  Rover.views = Rover.views || {};

  const HeaderNavBarView = Backbone.View.extend({
    el: '.js-header-navbar',

    initialize() {
      this.$ourServices = $('.js-our-services--dropdown');
      // Set data-qa-id for testing
      this.$ourServices
        .find('a')
        .first()
        .attr('data-qa-id', 'home-services-bar-links-dog-boarding');
    },

    events: {
      'click .js-show-our-services': 'toggleAllServices',
    },

    toggleAllServices(e) {
      e.preventDefault();
      if (this.$el.hasClass('show-all-services')) {
        this.hideAllServices();
      } else {
        this.showAllServices();
      }
    },

    showAllServices() {
      this.$el.addClass('show-all-services');
      this.$ourServices.css('transform', `translateY(${$('.js-header-navbar').outerHeight()}px)`);
    },

    hideAllServices() {
      this.$el.removeClass('show-all-services');
      this.$ourServices.css('transform', 'translateY(-100%)');
    },
  });
  Rover.views.HeaderNavBarView = new HeaderNavBarView();
})();

// When the navbar is sticky, toggle the class name `js-navbar-is-sticky` on <body>.
// This supports CSS that needs to target the navbar only when it is actively sticky.
(() => {
  const { body } = document;

  // TODO (DEV-24346): once the experiments are removed,
  // only the check for `sticky-navbar` is needed.
  const stickyNavbarIsEnabled = () =>
    body.classList.contains('sticky-navbar') &&
    (body.classList.contains('sticky-navbar-mobile-flag-on') ||
      body.classList.contains('sticky-navbar-desktop-flag-on'));

  const navbarIsSticky = () =>
    // If we have scrolled at all,
    window.pageYOffset > 0 &&
    // and we have scrolled enough for the navbar to have moved,
    // then the navbar is sticky.
    window.pageYOffset === document.querySelector('.js-navbar-container').offsetTop;

  // Do not use `.toggle(...)` - IE11 implements it incorrectly:
  // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/11865865/
  const toggleClass = (element, className, shouldToggle) =>
    element.classList[shouldToggle ? 'add' : 'remove'](className);

  const toggleStickyNavbarClassName = () =>
    requestAnimationFrame(() => toggleClass(body, 'js-navbar-is-sticky', navbarIsSticky()));

  if (stickyNavbarIsEnabled()) {
    const millisecondsPerFrame = 1000 / 60;

    // Throttle calls to limit unnecessary layouts and paints
    const throttledToggle = _.throttle(toggleStickyNavbarClassName, millisecondsPerFrame * 12);

    // Calculate initial state
    throttledToggle();
    // Recalculate on each scroll
    $(document).on('scroll', throttledToggle);
    // Recalculate in case of breakpoint changes
    $(window).on('resize', throttledToggle);
  }
})();



// WEBPACK FOOTER //
// ./js/components/header_navbar.js